export const TestBanner = () => {
  return (
    <section className="mt-6 w-full rounded-xl border border-dashed border-default-200 bg-default-50 p-6 text-center">
      <h3 className="text-lg font-semibold text-foreground">Тестовый компонент</h3>
      <p className="mt-2 text-sm text-default-500">
        Этот блок добавлен для демонстрации интеграции приложения в монорепозиторий.
      </p>
    </section>
  );
};
